import { Outlet, useParams } from "@tanstack/react-router";
import { ActingBanner } from "./ActingBanner";
import { Container } from "./Container";
import { Header } from "./Header";
import { useShellWorkspace } from "./useShellWorkspace";

/** Operator shell: band, acting banner (when an admin acts as the workspace), then the routed page. */
export function RootLayout() {
  const params = useParams({ strict: false });
  const workspaceId = typeof params.workspaceId === "string" ? params.workspaceId : undefined;
  const shellWorkspace = useShellWorkspace(workspaceId);
  const acting = workspaceId && shellWorkspace.data?.role === "admin" ? shellWorkspace.data : null;
  return (
    <div className="min-h-screen bg-app text-fg">
      <Header workspaceId={workspaceId} />
      {acting && workspaceId ? (
        <ActingBanner workspaceName={acting.name} workspaceId={workspaceId} />
      ) : null}
      <main className="py-6">
        <Container>
          <Outlet />
        </Container>
      </main>
    </div>
  );
}
